export default __webpack_public_path__ + "static/media/apeTown.aa915eea.mp4";